import type {
  AdvancedSearchResultType,
  SearchParameters,
} from 'lib-shared-types-api';

import { AppPathConfig } from 'utils/url/appPaths';
import { createAppUrl } from 'utils/url/createAppUrl';

import { convertFiltersObjectToString } from '../filters/convertFilters';
import { convertSortObjectToString } from '../sort/convertSort';

/**
 * Creates a Search URL params object that can be passed to `AppLink`.
 *
 * @param tab The current Search tab
 * @param params The current Search parameters
 */
export function createSearchUrlParams(
  tab: AdvancedSearchResultType,
  params: SearchParameters,
): AppPathConfig['/search/:tab'] {
  const { query, filters, strict, page, sort } = params;

  return {
    path: {
      tab,
    },
    search: {
      q: query || undefined,
      filters: convertFiltersObjectToString(filters) || undefined,
      sort: convertSortObjectToString(sort) || undefined,
      strict: strict ? 'true' : undefined,
      page: page && page > 1 ? page.toString() : undefined,
    },
  };
}

/**
 * Creates a Search URL with supported path and query parameters.
 *
 * @param tab The current Search tab
 * @param params The current Search parameters
 */
export function createSearchUrl(
  tab: AdvancedSearchResultType,
  params: SearchParameters,
): string {
  const url = createAppUrl({
    path: '/search/:tab',
    params: createSearchUrlParams(tab, params),
  });

  return url;
}
